import { Collapse, List, ListItem, ListItemText, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Fragment, memo, ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback } from 'react';
import PrintUnavailability from 'practice/components/pratice-unavailabilty/print';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: `${theme.spacing(4)} !important`,
    },
    nestedIcon: {
      minWidth: 'auto !important',
      paddingRight: theme.spacing(2),
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
    colorItems: {
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
  })
);

interface UnavailabilityManagementTableCollapseProps {
  onSubItemClick?: () => void;
  link: string;
  active: {
    aperturaPratica: boolean;
    stampaPratica: boolean;
  };
}

const UnavailabilityManagementTableCollapseComponent = ({
  onSubItemClick,
  link,
  active,
}: UnavailabilityManagementTableCollapseProps): ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  const [printUnavailabilityModal, setPrintUnavailabilityModal] = useState<boolean>(false);

  return (
    <Fragment>
      <ListItem
        button
        key="Gestione Pratica Irreperibilità"
        onClick={() => {
          handleClick();
        }}
        sx={{ pl: 6 }}
        className={classes.colorItems}
      >
        <ListItemText className={classes.colorItems} primary="Gestione Pratica Irreperibilità" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {active.aperturaPratica ? (
            <Link
              key={`${link}/nuova-pratica/irreperibilita`}
              to={`${link}/nuova-pratica/irreperibilita`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Apertura Pratica" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.stampaPratica ? (
            <ListItem
              button
              onClick={() => {
                if (onSubItemClick) {
                  onSubItemClick();
                  setPrintUnavailabilityModal(true);
                }
              }}
              sx={{ pl: 8 }}
            >
              <ListItemText className={classes.colorItems} primary="Stampa per Prefettura" />
            </ListItem>
          ) : undefined}
        </List>
      </Collapse>
      <PrintUnavailability
        isOpen={printUnavailabilityModal}
        onClose={() => setPrintUnavailabilityModal(false)}
      />
    </Fragment>
  );
};

UnavailabilityManagementTableCollapseComponent.displayName = 'Servive Table Collapse Item';

const UnavailabilityManagementTableCollapse = memo(UnavailabilityManagementTableCollapseComponent);

export default UnavailabilityManagementTableCollapse;
